import CustomEvents from "@/common/constants/customEvents";
import eventBus from "@/common/services/eventBus";

class DirHandleCenter {
    private _dirHandles: FileSystemDirectoryHandle[]

    constructor() {
        this._dirHandles = [];
    }

    get dirHandles() {
        return this._dirHandles;
    }

    addDirHandle(dirHandle: FileSystemDirectoryHandle) {
        this._dirHandles.push(dirHandle);
        eventBus.emit(CustomEvents.DIR_HANDLE_CHANGE);
    }

    removeDirHandle(dirHandle: FileSystemDirectoryHandle) {
        const index = this._dirHandles.indexOf(dirHandle);
        if (index > -1) {
            this._dirHandles.splice(index, 1);
            eventBus.emit(CustomEvents.DIR_HANDLE_CHANGE);
        }
    }

    remove(index: number) {
        this._dirHandles.splice(index, 1);
        eventBus.emit(CustomEvents.DIR_HANDLE_CHANGE);
    }

    clear() {
        this._dirHandles = [];
        eventBus.emit(CustomEvents.DIR_HANDLE_CHANGE);
    }

    /**
     * 根据之前用户授权的目录句柄，获取当前传入的文件句柄所在的目录句柄，解决批量写文件不用每个文件都需要用户授权
     * @param originFileHandle showOpenFilePicker 返回的文件句柄
     * @returns 如果文件句柄在之前授权的目录句柄中，则返回目录句柄，否则返回原始文件句柄
     */
    async getFileHandle(originFileHandle: FileSystemFileHandle): Promise<FileSystemFileHandle> {
        for (let dirHandle of this._dirHandles) {
            const relativePaths = await dirHandle.resolve(originFileHandle);

            if (relativePaths === null) {
                // 不在目录句柄中
                continue;
            } else {
                // relativePaths 是一个包含名称的数组，指示相对路径
                let currentDirHandle = dirHandle;
                // 除了最后一个元素(文件名)外的所有元素都是目录
                for (let i = 0; i < relativePaths.length - 1; i++) {
                    currentDirHandle = await currentDirHandle.getDirectoryHandle(relativePaths[i]);
                }
                // 最后一个元素是文件名
                const fileHandle = await currentDirHandle.getFileHandle(relativePaths[relativePaths.length - 1]);
                return fileHandle;
            }
        }
        return originFileHandle;
    }
}

const dirHandleCenter = new DirHandleCenter();
export { DirHandleCenter, dirHandleCenter } 